<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>模拟充提</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input v-model="userId" placeholder="用户ID" clearable>
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="type" placeholder="类型选择" clearable>
                <el-option
                  v-for="item in typeList"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button type="primary" @click="getList">查询</el-button>
          </div>

          <div class="item">
            <el-button type="primary" @click="show('deposit')"
              >模拟充值</el-button
            >
          </div>
          <div class="item">
            <el-button type="primary" @click="show('withdraw')"
              >模拟提现</el-button
            >
          </div>
          <div class="item">
            <el-button type="primary" @click="dialogRebateVisible = true"
              >模拟返佣</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="calc(100vh - 360px)" size="small">
        <el-table-column prop="userId" label="用户ID" />
        <el-table-column prop="txCoin" label="币种" />
        <el-table-column prop="txAmount" label="数量" />
        <el-table-column prop="txNetworkId" label="hash" />
        <el-table-column prop="txToWallet" label="钱包" />
        <el-table-column prop="" label="类型">
          <template slot-scope="scope">
            <span>{{ scope.row.txType == 1 ? '充值' : '提现' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </Pagination>

      <el-dialog
        :title="title === 'deposit' ? '模拟充值' : '模拟提现'"
        :visible.sync="dialogVisible"
        width="400px"
        @close="close"
        class="myDialog"
      >
        <el-form
          ref="formData"
          :model="formData"
          size="medium"
          label-width="100px"
        >
          <el-form-item label="用户ID" prop="" required>
            <el-input v-model="formData.userId"></el-input>
          </el-form-item>
          <el-form-item label="金额" prop="" required>
            <el-input-number
              :min="1"
              v-model="formData.amount"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="地址"
            prop=""
            required
            v-if="title === 'withdraw'"
          >
            <el-input v-model="formData.address"></el-input>
          </el-form-item>
          <el-form-item label="hash值" prop="">
            <el-input v-model="formData.hash"></el-input>
          </el-form-item>
          <el-form-item label="创建时间" prop="">
            <el-date-picker
              v-model="formData.createTime"
              type="datetime"
              value-format="timestamp"
              placeholder="选择创建时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="handleSave">确定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="模拟返佣"
        :visible.sync="dialogRebateVisible"
        width="400px"
        @close="closeRebate"
        class="myDialog"
      >
        <el-form
          ref="rebateForm"
          :model="formDataRebate"
          size="medium"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="合伙人UID" prop="channelUserId" required>
            <el-input v-model="formDataRebate.channelUserId"></el-input>
          </el-form-item>
          <el-form-item label="金额" prop="amount" required>
            <el-input-number
              :min="1"
              v-model="formDataRebate.amount"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="返佣时间" prop="time" required>
            <el-date-picker
              v-model="formDataRebate.time"
              type="datetime"
              value-format="timestamp"
              placeholder="选择返佣时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="closeRebate">取消</el-button>
          <el-button type="primary" @click="handleRebate('rebateForm')"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from 'components/pagination'
import api from './api'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      userId: '',
      type: '',
      typeList: [
        {
          label: '充值',
          key: 1,
        },
        { label: '提现', key: -1 },
      ],
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      title: '',
      formData: {
        userId: '',
        amount: '',
        hash: '',
        createTime: '',
        address: '',
      },
      dialogRebateVisible: false,
      formDataRebate: {
        channelUserId: '',
        amount: '',
        time: '',
      },
      rules: {
        channelUserId: {
          required: true,
          message: '请输入合伙人UID',
          trigger: 'blur',
        },
        amount: {
          required: true,
          message: '请输入金额',
          trigger: 'blur',
        },
        time: {
          required: true,
          message: '请输入返佣时间',
          trigger: 'blur',
        },
      },
    }
  },
  computed: {},
  mounted() {
    this.getList()
  },
  methods: {
    getList(pagination) {
      api
        .mockList({
          userId: this.userId,
          type: this.type,
          ...this.pagination,
          ...pagination,
        })
        .then((res) => {
          if (res.code == 0) {
            const { totalCount, list } = res.data
            this.tabList = list
            this.totalCount = totalCount
          }
        })
    },
    paginationHandle(pagination) {
      this.pagination = pagination
      this.getList()
    },
    show(str) {
      this.title = str
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
      this.formData = {
        userId: '',
        amount: '',
        hash: '',
        createTime: '',
        address: '',
      }
    },
    closeRebate() {
      this.$refs.rebateForm.resetFields()
      this.dialogRebateVisible = false
    },
    handleSave() {
      let url = ''
      if (this.formData.userId == '') {
        return this.$message.error('请输入用户ID')
      }
      if (!this.formData.amount) {
        return this.$message.error('金额必须大于0')
      }
      if (this.title === 'withdraw' && this.formData.address == '') {
        return this.$message.error('请输入地址')
      }
      this.title === 'withdraw' ? (url = 'mockWithdraw') : (url = 'mockDeposit')
      api[url](this.formData).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功！')
          this.close()
          this.getList({
            page: 1,
            size: 25,
          })
        }
      })
    },
    handleRebate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          api
            .mockRebate({
              ...this.formDataRebate,
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功！')
                this.closeRebate()
                this.getList({
                  page: 1,
                  size: 25,
                })
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import url('~styles/button.less');
.myDialog {
  /deep/ .el-input {
    width: 200px;
  }
}
</style>
